<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 15 12"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.93933 7.70965C9.95202 7.71499 9.96618 7.71573 9.97935 7.71174C9.99253 7.70775 10.0039 7.69927 10.0115 7.68779L11.7171 5.02874C11.721 5.022 11.7236 5.01455 11.7246 5.00682C11.7256 4.9991 11.7251 4.99125 11.723 4.98373C11.721 4.97621 11.7175 4.96916 11.7127 4.963C11.708 4.95684 11.702 4.95168 11.6953 4.94783H11.6821C9.22427 4.09063 6.92822 5.73505 3.42072 5.82252C3.38165 5.82532 3.34526 5.84343 3.31947 5.87291C3.29367 5.90239 3.28055 5.94086 3.28296 5.97996C3.28543 6.00118 3.29133 6.02186 3.30045 6.04119L7.08566 11.9453C7.09529 11.9671 7.11297 11.9842 7.13499 11.9932C7.15702 12.0022 7.18166 12.0023 7.20374 11.9934C7.22275 11.9853 7.23835 11.9708 7.24792 11.9525C7.25748 11.9342 7.26042 11.9131 7.25622 11.8928L6.44277 8.15356C6.43933 8.13793 6.44193 8.12159 6.45004 8.1078C6.45816 8.09402 6.47118 8.0838 6.4865 8.07921C6.77952 7.95675 8.92469 7.21546 9.93933 7.69872M14.0263 1.3966L12.6246 3.59644C12.6113 3.61907 12.5901 3.63603 12.5652 3.6441C12.5402 3.65216 12.5131 3.65076 12.489 3.64017C9.2527 1.99576 5.51778 5.02218 2.21146 4.29619C2.18103 4.28986 2.15431 4.27179 2.13712 4.24589L0.0203727 0.943946C0.0105421 0.927308 0.00410023 0.90889 0.00141803 0.889752C-0.00126418 0.870613 -0.000133681 0.851134 0.0047444 0.832434C0.00962249 0.813735 0.0181518 0.796186 0.029841 0.780797C0.0415303 0.765408 0.0561486 0.752483 0.072854 0.742768C0.102455 0.725216 0.137419 0.719001 0.171256 0.725274C0.992109 0.913051 1.82398 1.0489 2.66193 1.132C7.65421 1.40316 10.3723 -1.62545 13.9957 1.24571C14.0189 1.26244 14.0347 1.28741 14.04 1.31548C14.0453 1.34356 14.0396 1.37259 14.0241 1.3966" :fill="fill"/>
  </svg>
</template>

<script>
export default {
  name: 'Fanatics',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#E53D2E'
    },
  },
};

</script>
